module.exports = __webpack_public_path__ + "static/media/video-bolsas-y-zapatos-2020.8b3d8fe0.mp4";